import { Button, Modal, ModalProps } from "antd";
import styles from "./styles.module.scss";
import classNames from "classnames";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { queryKeys } from "../../../constants/constans";
import { getListStaffDuplicate } from "../../../api/tableSession";

interface IProps extends ModalProps {
  isVisible?: boolean;
  handleCancel: () => void;
}
const ModalDuplicateStaff = (props: IProps) => {
  const { isVisible, handleCancel } = props;

  const { data: listStaffDuplicate } = useQuery(
    queryKeys.listStaffDuplicate,
    getListStaffDuplicate
  );

  const handleShowInfoTable = (infoSession: any) => {
    const tableId = document.getElementById(infoSession?._id);
    if (tableId) {
      handleCancel();
      tableId.click();
    }
  };

  return (
    <Modal
      open={isVisible}
      footer={null}
      closable={false}
      className={styles.modalDuplicateStaff}
      width={500}
      zIndex={1001}
      centered
    >
      <div className={styles.modalSettingContainer}>
        <div className={styles.header}>スタッフ重複情報</div>
        <div className={styles.content}>
          {listStaffDuplicate?.data?.map((item: any) => (
            <div className={styles.row}>
              <div className={styles.warning}>!</div>「
              <div>
                {item?.staffInfo?.staffName}」が
                {item?.table &&
                  Array.isArray(item?.table) &&
                  item?.table?.map((table: any, index: number) => {
                    return (
                      <>
                        <span
                          onClick={() =>
                            handleShowInfoTable(table?.infoSession)
                          }
                        >
                          {table?.infoTable?.code}
                          {table?.infoTable?.no}
                        </span>
                        {index !== item?.table?.length - 1 && "卓と"}
                      </>
                    );
                  })}
                卓で時間が重複しています
              </div>
            </div>
          ))}
        </div>
        <div className={styles.btnContainer}>
          <Button
            className={classNames(styles.btn, "btn-default")}
            onClick={handleCancel}
          >
            閉じる
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default ModalDuplicateStaff;
